import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "../Homepage/HomePageMain.module.css";
import Footer from "../common/UI/Footer";
import { useCategories } from "../hooks/categories/useCategories";
import Loading from "../common/HousGlass Loader/Loading";
import ShortStoriesBanner from "./language/ShortStoriesBanner";
import OverlayHome from "../Homepage/components/OverlayHome";
import { getPageMetaById } from '../api/PageMetaManager';
import { Helmet } from "react-helmet";
import GarhwaliCategories from "./GarhwaliCategories";
function ShortStoriesGarhwali() {
  const { language } = useParams();
  const [dataAudio, setDataAudio] = useState("");
  const { categories, isLoading, isError, error } = useCategories(
    "Audio",
    language || "hindi"
  );

  const [meta, setMeta] = useState({
    title: "",
    description: "",
    keywords: ""
  });

  useEffect(() => {
    const fetchMeta = async (id) => {
      try {
        const data = await getPageMetaById(id);
        setMeta({
          title: data.meta_title || '',
          description: data.meta_description || '',
          keywords: data.meta_keywords || ''
        });
      } catch (error) {
        console.warn('Meta not found, using defaults');
        setMeta({ title: '', description: '', keywords: '' });
      }
    };

    if (language === "hindi") {
      fetchMeta(2);
      setDataAudio("HindiShortAudios");
    } else if (language === "english") {
      fetchMeta(4);
      setDataAudio("EnglishShortAudios");
    } else if (language === "garhwali") {
      fetchMeta(3);
      setDataAudio("GarhwaliShortAudios");
    } else if (language === "kumaoni") {
      fetchMeta(1);  // default or some id for kumaoni
      setDataAudio("KumaoniShortAudios");
    } else {
      fetchMeta(2) // default meta id if no language matched
    }
  }, [language]);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "300px",
        }}
      >
        <Loading />
      </div>
    );
  }

  if (isError) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "red" }}>
        Error loading categories:{" "}
        {error?.message || "An unknown error occurred"}
      </div>
    );
  }

  if (!categories || categories.length === 0) {
    return (
      <>
        <ShortStoriesBanner language={language} />
        <div style={{ padding: "20px", textAlign: "center" }}>
          No categories found. Please try again later.
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
    <Helmet>
      <title>{meta.title || 'Short Stories - SunoKahaniyan'}</title>
      <meta
        name="description"
        content={
          meta.description ||
          'Explore a variety of short stories in audio format across different languages on SunoKahaniyan.'
        }
      />
      <meta name="keywords" content={meta.keywords || 'audio stories, ebooks, videos, hindi kahaniyan, suno kahaniyan'} />
    </Helmet>
    <div className={styles.homeBackground}>
      <OverlayHome type={dataAudio} category={"audio"} />
      <div className={`${styles.homepageContainer} ${styles.contentOverlap}`}>
        <GarhwaliCategories
          categories={categories.map((category) => ({
            id: category.id,
            name: category.name,
          }))}
        />
        <Footer />
      </div>
    </div>
    </>
  );
}

export default ShortStoriesGarhwali;
